import React, {
  useMemo,
  useState
} from 'react'

import cn from 'classnames'

import Avatar, { AvatarData } from '../Avatar/Avatar'
import { iconName } from '../Icon2/constants'
import Icon from '../Icon2/Icon'
import Tooltip from '../Tooltip/Tooltip'

export type GenericCardProps = {
  title?: string
  active?: boolean
  mainContent?: JSX.Element
  footerContent?: JSX.Element
  data?: any
  onActiveToggle: (state: any, event: any) => void
  disableActiveFn?: boolean
  testId?: string
  starActiveTooltip?: string
  starInActiveTooltip?: string
  avatars?: AvatarData[]
  modified?: string
  type?: 'text' | 'image'
  icons?: JSX.Element
  lastModifiedTooltipContent?: string
  modifiedAtTooltipText?: string
}

export const GenericCardV2 = (props: GenericCardProps) => {

  let { title, active = false, onActiveToggle = state => { }, mainContent, footerContent, data = "", disableActiveFn = false, testId = "cs-generic-card", avatars, type, modified = "March 30, 2020", lastModifiedTooltipContent = "Mar 30, 2020 1:15PM", modifiedAtTooltipText } = props;

  const classNames = cn(['GenericCard'], ['GenericCard__v2'])

  return (
    <div className={classNames} data-test-id={testId}>
      <Heading
        title={title}
        active={active}
        onActiveToggle={onActiveToggle}
        data={data}
        starActiveTooltip={props.starActiveTooltip}
        starInactiveTooltip={props.starInActiveTooltip}
        icons={props.icons}
        disableActiveFn={disableActiveFn} />
      <div className="GenericCard__content">
        {mainContent}
      </div>
      <Footer avatars={avatars} type={type} modified={modified} footerContent={footerContent} lastModifiedTooltipContent={lastModifiedTooltipContent} modifiedAtTooltipText={modifiedAtTooltipText} />
    </div>
  )
}

const Footer = (
  { avatars, type, modified, footerContent, lastModifiedTooltipContent, modifiedAtTooltipText: modifiedAtTooltipText }: { avatars?: AvatarData[], modified: string, type?: 'text' | 'image', footerContent?: JSX.Element, lastModifiedTooltipContent?: string, modifiedAtTooltipText?: string }
) => {
  return useMemo(() => {
    return (
      <div className="GenericCard__footer">
        {
          footerContent ?
            footerContent :
            <Avatar avatars={avatars} staticCustomIcon={true} type={type} />
        }
        {modified && lastModifiedTooltipContent && (
          <Tooltip
            variantType={'basic'}
            showArrow={true}
            content={modifiedAtTooltipText ? modifiedAtTooltipText : `Last deployed on ${lastModifiedTooltipContent}`}
            position="top">
            <div className="GenericCard__modified flex-v-center">
              <Icon version="v2" icon={'ClockMedium'} />
              <span className="GenericCard__modified-date">{modified}</span>
            </div>
          </Tooltip>
        )}
      </div>
    )
  }, [modified, avatars, type, lastModifiedTooltipContent])
}

const Heading = (
  { title, active, onActiveToggle, data, starActiveTooltip, starInactiveTooltip, icons, disableActiveFn }: { title: string, active: boolean, onActiveToggle: (state: any, event: any) => void, data: any, starActiveTooltip: string, starInactiveTooltip: string, icons?: JSX.Element, disableActiveFn: boolean }
) => {
  const enableStar = !disableActiveFn;
  let [isActive, setIsActive] = useState(active);

  const handleStarClick = (event: any) => {
    setIsActive(!isActive)
    onActiveToggle({ isActive: !isActive, data }, event)
  };

  return (
    <div className="GenericCard__heading">
      <h4 className="GenericCard__title flex-v-center">
        {icons ? <div className="mr-10">{icons}</div> : <></>}
        {title?.length > 50 ? (
          <Tooltip variantType="basic" showArrow content={title} position="top">
            <span className="GenericCard__title--truncate">{title}</span>
          </Tooltip>
        ) : (
          <span>{title}</span>
        )}

        {
          enableStar ?
            <button
              className="GenericCard__star-button"
              onClick={handleStarClick}
              aria-label={`${isActive ? `Click to unstar ${title} stack` : `Click to star ${title} stack`}`}>
              <Tooltip
                showArrow={true}
                variantType={'basic'}
                content={isActive ? starActiveTooltip : starInactiveTooltip}
                position="left">
                <Icon
                  icon={iconName.Star}
                  className={`GenericCard__star-icon ${isActive ? ' GenericCard__star-icon--active' : ''}`}></Icon>
              </Tooltip>
            </button> : <></>
        }
      </h4>
    </div>
  )
}